import { useEffect, useState } from 'react';
import { DEFAULT_LANG } from '../configs/i18n';
import { resolveTargetLang, applyTranslation, initGoogleTranslate } from '../utils/googleTranslateUtil';

// Reads this app's own culture cookie (or "?lang=" if present), applies the matching
// Google Translate language, and boots the Google Translate widget once the page is
// ready. Mount this once (Header, since it renders on every page via layout.js) - it
// returns the resolved language so the UI can reflect it, e.g. in the language
// selector. Changing language happens via the dropdown's ?lang= navigation, which
// also writes the culture cookie client-side (see handleLangSelect and
// googleTranslateUtil.js's selectCulture). A fresh mount here is all that's needed to
// stay in sync - no extra wiring required on route change.
export const useGoogleTranslate = () => {
    const [currentLang, setCurrentLang] = useState(DEFAULT_LANG);

    useEffect(() => {
        const lang = resolveTargetLang();
        setCurrentLang(lang);
        applyTranslation(lang);
        initGoogleTranslate();
    }, []);

    return { currentLang };
}
